// TODO: deprecated — APIProviders only feeds the legacy FileModal, which no
// call site triggers anymore. Replaced by AddImageModal / AddSoundModal /
// VideoModal / left-panel library. Safe to delete with FileModal and the
// remaining providers in this folder.
import React from "react";
import MyFilesComponent from "./providers/MyFilesComponent";
import AnimationOptionsComponent from "./providers/AnimationOptionsComponent";
import ShapesComponent from "./providers/ShapesComponent";
import CharactersComponent from "./providers/CharactersComponent";
import UploadComponent from "./providers/UploadComponent";
import YoutubeComponent from "./providers/YoutubeComponent";
import EuropeanaComponent from "./providers/EuropeanaComponent";
import FlickrComponent from "./providers/FlickrComponent";
import LogoComponent from "./providers/LogoComponent";
// import GoogleDriveComponent from './providers/GoogleDriveComponent';
// import AudioBlocksComponent from './AudioBlocksComponent';
// import PhetComponent from './PhetComponent';

import FlickrIcon from "./logos/flickrsvg.svg";
import EuropeanaIcon from "./logos/europeanaalt.svg";
import YoutubeIcon from "./logos/youtube.svg";
// import AudioBlocksIcon from './logos/storyblocks-ab-alt.svg';
import SoundTextToSpeechIcon from "./logos/SoundTextToSpeechIcon.png";
import imgTextToImageComponentIcon from "./logos/imgTextToImageIcon.png";
// import OpenClipArtIcon from './logos/openclipart.svg';
import LogoIcon from "./logos/avatar-gallery.png";

import i18n from "i18next";
import SoundTextToSpeechComponent from "./providers/SoundTextToSpeechComponent";
import imgTextToImageComponent from "./providers/imgTextToImageComponent";
import AvatarTextToSpeechComponent from "./providers/AvatarTextToSpeechComponent";

export default function menus(self) {
  let allowedMIME = self.props.visible || "";
  let commonProps = {
    onElementSelected: (name, element, type, id, options = {}) => {
      console.log("📌 [APIProviders] onElementSelected received:", {
        name,
        element,
        type,
        id,
        options,
      });
      console.log("📌 [APIProviders] fileModalResult:", self.props.fileModalResult);
      console.log("📌 [APIProviders] allowedMIME:", allowedMIME);
      self.setState({ name, element, type, id, options }, () => {
        console.log("📌 [APIProviders] state after set:", {
          name: self.state.name,
          element: self.state.element,
          type: self.state.type,
          id: self.state.id,
        });
      });
    },
    elementSelected: self.state.element,
    idSelected: self.state.id,
    onServerModal: self.props.onServerModal,
    calculateclick: true,
  };

  let avatar = self.props.fileModalResult && self.props.fileModalResult.id === "avatar";

  return [
    {
      name: (
        <span>
          <i className="material-icons">file_upload</i>
          {i18n.t("FileModal.APIProviders.UploadFiles")}
        </span>
      ),
      show: allowedMIME,
      component: UploadComponent,
      props: {
        ...commonProps,
        isBusy: self.props.isBusy,
        closeSideBar: (closeAlsoModal) => {
          self.setState({ pdfSelected: false });
          if (closeAlsoModal) {
            self.close();
          }
        },
        pdfSelected: self.state.pdfSelected,
        filesUploaded: self.props.filesUploaded,
        uploadFunction: self.props.uploadFunction,
        onUploadIdealStudioResource: self.props.onUploadIdealStudioResource,
        onNavItemsAdded: self.props.onNavItemsAdded,
        onIndexSelected: self.props.onIndexSelected,
        onNavItemSelected: self.props.onNavItemSelected,
        navItemsIds: self.props.navItemsIds,
        navItems: self.props.navItems,
        navItemSelected: self.props.navItemSelected,
        containedViews: self.props.containedViews,
        containedViewSelected: self.props.containedViewSelected,
        boxes: self.props.boxes,
        onBoxAdded: self.props.onBoxAdded,
      },
    },
    {
      name: (
        <span>
          <i className="material-icons">perm_media</i>
          {i18n.t("FileModal.APIProviders.MyFiles")}
        </span>
      ),
      show: allowedMIME,
      component: MyFilesComponent,
      props: {
        ...commonProps,
        elementSelectedType: self.state.type,
        pdfSelected: self.state.pdfSelected,
        filesUploaded: self.props.filesUploaded,
        onNavItemsAdded: self.props.onNavItemsAdded,
        onIndexSelected: self.props.onIndexSelected,
        onNavItemSelected: self.props.onNavItemSelected,
        navItemsIds: self.props.navItemsIds,
        navItems: self.props.navItems,
        navItemSelected: self.props.navItemSelected,
        containedViews: self.props.containedViews,
        containedViewSelected: self.props.containedViewSelected,
        boxes: self.props.boxes,
        deleteFileFromServer: self.props.deleteFileFromServer,
        onBoxAdded: self.props.onBoxAdded,
      },
    },
    {
      name: "imgTextToImage",
      icon: imgTextToImageComponentIcon,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("image")),
      //show: allowedMIME, // !(avatar) && (allowedMIME === "*" || allowedMIME.match('audio')),
      component: imgTextToImageComponent,
      props: {
        ...commonProps,
        ttiGenerateImageFile: self.props.ttiGenerateImageFile,
        calculateclick: false,
      },
    },
    {
      name: "SoundTextToSpeech",
      icon: SoundTextToSpeechIcon,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("audio")),
      component: SoundTextToSpeechComponent,
      props: {
        ...commonProps,
        ttsGenerateSoundFile: self.props.ttsGenerateSoundFile,
        calculateclick: false,
      },
    },
    {
      name: (
        <span>
          <i className="material-icons">face</i>
          {i18n.t("FileModal.APIProviders.AIAvatarsText")}
        </span>
      ),
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("video")),
      component: AvatarTextToSpeechComponent,
      props: {
        ...commonProps,
        calculateclick: false,
      },
    },
    {
      name: (
        <span>
          <i className="material-icons">local_library</i>
          {i18n.t("FileModal.APIProviders.library")}
        </span>
      ),
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("image")),
      //show: allowedMIME,
      component: AnimationOptionsComponent,
      props: {
        ...commonProps,
        elementSelectedType: self.state.type,
        pdfSelected: self.state.pdfSelected,
        filesUploaded: self.props.filesUploaded,
        onNavItemsAdded: self.props.onNavItemsAdded,
        onIndexSelected: self.props.onIndexSelected,
        onNavItemSelected: self.props.onNavItemSelected,
        navItemsIds: self.props.navItemsIds,
        navItems: self.props.navItems,
        navItemSelected: self.props.navItemSelected,
        containedViews: self.props.containedViews,
        containedViewSelected: self.props.containedViewSelected,
        boxes: self.props.boxes,
        deleteFileFromServer: self.props.deleteFileFromServer,
        onBoxAdded: self.props.onBoxAdded,
      },
    },
    {
      name: (
        <span>
          <i className="material-icons">star</i>
          {i18n.t("FileModal.APIProviders.Animations")}
        </span>
      ),
      //show: allowedMIME,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("image")),
      component: ShapesComponent,
      props: {
        ...commonProps,
        elementSelectedType: self.state.type,
        pdfSelected: self.state.pdfSelected,
        filesUploaded: self.props.filesUploaded,
        onNavItemsAdded: self.props.onNavItemsAdded,
        onIndexSelected: self.props.onIndexSelected,
        onNavItemSelected: self.props.onNavItemSelected,
        navItemsIds: self.props.navItemsIds,
        navItems: self.props.navItems,
        navItemSelected: self.props.navItemSelected,
        containedViews: self.props.containedViews,
        containedViewSelected: self.props.containedViewSelected,
        boxes: self.props.boxes,
        deleteFileFromServer: self.props.deleteFileFromServer,
        onBoxAdded: self.props.onBoxAdded,
      },
    },
    {
      name: (
        <span>
          <i className="material-icons">face</i>
          {i18n.t("FileModal.APIProviders.Characters")}
        </span>
      ),
      //show: allowedMIME,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("image")),
      component: CharactersComponent,
      props: {
        ...commonProps,
        elementSelectedType: self.state.type,
        pdfSelected: self.state.pdfSelected,
        filesUploaded: self.props.filesUploaded,
        onNavItemsAdded: self.props.onNavItemsAdded,
        onIndexSelected: self.props.onIndexSelected,
        onNavItemSelected: self.props.onNavItemSelected,
        navItemsIds: self.props.navItemsIds,
        navItems: self.props.navItems,
        navItemSelected: self.props.navItemSelected,
        containedViews: self.props.containedViews,
        containedViewSelected: self.props.containedViewSelected,
        boxes: self.props.boxes,
        deleteFileFromServer: self.props.deleteFileFromServer,
        onBoxAdded: self.props.onBoxAdded,
      },
    },
    /* {
            name: 'Dropbox',
            icon: DropboxIcon,
            show: !(avatar) ? ((allowedMIME) ? allowedMIME : false) : false,
            component: DropboxComponent,
            props: {
                ...commonProps,
                isBusy: self.props.isBusy,
                elementSelectedType: self.state.type,
                allowedMIME,
                pdfSelected: self.state.pdfSelected,
                filesUploaded: self.props.filesUploaded,
                uploadFunction: self.props.uploadFunction,
            },
        },*/
    /* {
         name: 'Google',
         icon: SoundCloudIcon,
         show: !(avatar) && (allowedMIME === "*" || allowedMIME.match('image')),
         component: GoogleDriveComponent,
         props: { ...commonProps },
         },*/
    {
      name: "Youtube",
      icon: YoutubeIcon,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("video")),
      component: YoutubeComponent,
      props: { ...commonProps },
    },
    {
      name: "Flickr",
      icon: FlickrIcon,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("image")),
      component: FlickrComponent,
      props: { ...commonProps },
    },
    {
      name: "Europeana",
      icon: EuropeanaIcon,
      show: !avatar && (allowedMIME === "*" || allowedMIME.match("image")),
      component: EuropeanaComponent,
      props: { ...commonProps },
    },
    /* {
            name: 'Phet',
            icon: YoutubeIcon,
            show: !(avatar) && (allowedMIME === "*" || allowedMIME.match('video')),
            component: PhetComponent,
            props: { ...commonProps },
        },*/
    /*      {
            name: 'Giphy',
            icon: GiphyIcon,
            show: !(avatar) && (allowedMIME === "*" || allowedMIME.match('image')),
            component: GiphyComponent,
            props: { ...commonProps },
        },*/
    // {
    //     name: 'SoundCloud',
    //     icon: SoundCloudIcon,
    //     show: !(avatar) && (allowedMIME === "*" || allowedMIME.match('audio')),
    //     component: SoundCloudComponent,
    //     props: { ...commonProps },
    // },

    // {
    //     name: 'AudioBlocks',
    //     icon: AudioBlocksIcon,
    //     show: (allowedMIME === "*" || allowedMIME.match('audio')),
    //     component: AudioBlocksComponent
    // },
    /* {
            name: 'OpenClipArt',
            icon: OpenClipArtIcon,
            show: !(avatar) && (allowedMIME === "*" || allowedMIME.match('image')),
            component: OpenClipArtComponent,
            props: { ...commonProps },
        },
        {
          name: 'Thingiverse',
          icon: ThingiverseIcon,
          show: (allowedMIME === "*" || allowedMIME.match('application')),
          component: ThingiverseComponent,
          props: { ...commonProps },
      }*/
    {
      name: "Avatar",
      icon: LogoIcon,
      show: avatar,
      component: LogoComponent,
      props: { ...commonProps },
    },
  ];
}
